document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.ccs-card');

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function updateActiveCard() {
    if (!isMobile()) {
      // Remove all active classes on desktop
      cards.forEach(card => card.classList.remove('active'));
      return;
    }

    let closestCard = null;
    let closestDistance = Infinity;

    cards.forEach(card => {
      const rect = card.getBoundingClientRect();
      const cardCenter = rect.left + rect.width / 2;
      const screenCenter = window.innerWidth / 2;

      const distance = Math.abs(screenCenter - cardCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestCard = card;
      }
    });

    cards.forEach(card => card.classList.remove('active'));
    if (closestCard) closestCard.classList.add('active');
  }

  // Run initially
  updateActiveCard();

  // Run on scroll (important for slider)
  document.querySelector('.ccs-wrapper')?.addEventListener('scroll', updateActiveCard);

  // Run on resize
  window.addEventListener('resize', updateActiveCard);
});

// Desktop slider navigation
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.ccs-section--slider .ccs-wrapper');
  const prevBtn = document.querySelector('.ccs-prev');
  const nextBtn = document.querySelector('.ccs-next');

  if (!wrapper || !prevBtn || !nextBtn) return;

  const cards = wrapper.querySelectorAll('.ccs-card');

  function getScrollAmount() {
    if (!cards.length) return 0;

    const card = cards[0];
    const style = window.getComputedStyle(wrapper);
    const gap = parseInt(style.gap) || 0;

    return card.offsetWidth + gap; // 👈 1 card scroll
  }

  function updateArrows() {
    const scrollLeft = wrapper.scrollLeft;
    const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

    // Prev button
    if (scrollLeft <= 5) {
      prevBtn.classList.add('disabled');
    } else {
      prevBtn.classList.remove('disabled');
    }

    // Next button
    if (scrollLeft >= maxScroll - 5) {
      nextBtn.classList.add('disabled');
    } else {
      nextBtn.classList.remove('disabled');
    }
  }

  nextBtn.addEventListener('click', () => {
    wrapper.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  prevBtn.addEventListener('click', () => {
    wrapper.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  // Update on scroll
  wrapper.addEventListener('scroll', updateArrows);

  // Initial state
  updateArrows();

  // Update on resize
  window.addEventListener('resize', updateArrows);
});